import axios from "axios";
import { API } from "@/lib/api";

let tracked = {};

function send(event, page, meta = {}) {
  const key = `${event}:${page}:${JSON.stringify(meta)}`;
  if (event === "page_view" && tracked[key]) return;
  tracked[key] = true;
  axios.post(`${API}/analytics/event`, { event, page, meta }).catch(() => {});
}

export function trackPageView(page) {
  send("page_view", page || window.location.pathname);
}

export function trackCTA(ctaName, page) {
  send("cta_click", page || window.location.pathname, { cta: ctaName });
}

export function trackFormSubmit(formType) {
  send(`form_submit_${formType}`, window.location.pathname);
}
